export enum LocalStorageItem {
  animations = 'animations',
  lang = 'lang',
}

export const queryStringParamsToPreserve: Record<string, LocalStorageItem> = {
  animations: LocalStorageItem.animations,
  lang: LocalStorageItem.lang,
};
